export const EN = 'en';
export const RU = 'ru';
